import ClipBoardIcon from "../../../../icons/clipBoardIcon";
import UploadDocIcon from "../../../../icons/uploadDocIcon";
import DownloadDocIcon from "../../../../icons/downloadDocIcon";

const DocumentsTab = ({ t }) => {
  const requests = [
    { name: "نسخة العقد " },
    { name: "العقد الموقع" },
    { name: "الهوية الوطنية" },
    { name: " صوره للحساب البنكي" },
  ];
  return (
    <div className="bg-[#182443] p-8 rounded-lg space-y-4">
      <h3 className="text-lg font-bold">{t("docs")}</h3>
      <div>
        <section>
          {requests.map((r, i) => {
            return (
              <div
                key={i}
                className="p-6 mt-6 rounded-lg border border-[#DADADA] flex justify-between items-center"
              >
                <div className="flex items-center gap-4">
                  <span className="grid place-content-center size-10 rounded-xl bg-[#e7e6ff] ">
                    <ClipBoardIcon stroke={"#1e4071"} />
                  </span>

                  <p className="font-semibold">{r.name}</p>
                </div>
                <div className="flex items-center justify-center gap-1">
                  <UploadDocIcon />
                  <DownloadDocIcon />
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default DocumentsTab;
